import React from 'react'
import Modal from 'react-bootstrap/Modal'
import './Modal.scss'

interface IModalBodyProps {
	bodyTitle: string
	bodyText: string
}

export const ModalBody = ({ bodyTitle, bodyText }: IModalBodyProps) => (
	<Modal.Body>
		<div className="body-text">
			<div>
				<div className="refer-friends-subtitle font-color">
					{bodyTitle}
				</div>
				<div
					className="font-color"
					dangerouslySetInnerHTML={{ __html: bodyText }}></div>
			</div>
		</div>
	</Modal.Body>
)
